export default [
    {
        path: '/states',
        name: 'states',
        component: () => import ('./pages/Index')
    },
]